import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/storybook-components';
import MoveIcon from '@learningblocks/exp-constants/lib/Images/move.svg';
import './style.scss';

/**
 * SlideThreeOption: Option component associated with DesignSection
 * first slide.
 */

export function SlideThreeOption(props) {
  return (
    <div className='slideOption'>
      <div
        className='slideOption__icon'
        onClick={props.addCard}
        style={{backgroundColor: props.groupColor}}>
        <Image src={MoveIcon} alt='optionIcon' />
      </div>
      <div className='slideOption__text'>
        <p>{props.text}</p>
      </div>
    </div>
  );
}

SlideThreeOption.propTypes = {
  /**
   * Function to invoke when SetAsNext Button is clicked
   */
  addCard: PropTypes.func,
  /**
   * SHex value for the group color.
   */
  groupColor: PropTypes.string,
  /**
   * Text to be displayed in Card.
   */
  text: PropTypes.string,
};

SlideThreeOption.defaultProps = {
  groupColor: '#ffffff',
  text: '',
};
